export { default as Navigation } from './Navigation';
export { default as Video } from './Video';
export { default as Result } from './Result';
export { default as Questions } from './Questions';
export { default as QuestionFeedback } from './QuestionFeedback';